/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Senddrafts_Entrybutton3Inputs */

const en_coinvestments_senddrafts_entrybutton3 = /** @type {(inputs: Coinvestments_Senddrafts_Entrybutton3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send drafts (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Send drafts ({count})" |
*
* @param {Coinvestments_Senddrafts_Entrybutton3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_entrybutton3 = /** @type {((inputs: Coinvestments_Senddrafts_Entrybutton3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Entrybutton3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_entrybutton3(inputs)
});
export { coinvestments_senddrafts_entrybutton3 as "coInvestments_sendDrafts_entryButton" }